/* global axios */
import ApiClient from './ApiClient';

class SegmentsAPI extends ApiClient {
  constructor() {
    super('segments', { accountScoped: true });
  }

  getMembers(segmentId, page = 1) {
    return axios.get(`${this.url}/${segmentId}/members?page=${page}`);
  }

  getContactSegments(contactId) {
    return axios.get(
      `${this.url.replace('/segments', '')}/contacts/${contactId}/segments`
    );
  }

  // Operacoes de conjunto: o resultado e sempre lista NOVA, originais intactas.
  combinePreview(operation, segmentIds) {
    return axios.post(`${this.url}/combine_preview`, {
      operation,
      segment_ids: segmentIds,
    });
  }

  combine(operation, segmentIds, name, description) {
    return axios.post(`${this.url}/combine`, {
      operation,
      segment_ids: segmentIds,
      name,
      description,
    });
  }

  previewRules(segmentId, query) {
    return axios.post(`${this.url}/${segmentId}/preview_rules`, { query });
  }

  addContacts(segmentId, contactIds) {
    return axios.post(`${this.url}/${segmentId}/add_contacts`, {
      contact_ids: contactIds,
    });
  }

  removeContacts(segmentId, contactIds) {
    return axios.post(`${this.url}/${segmentId}/remove_contacts`, {
      contact_ids: contactIds,
    });
  }

  getMembersSearch(segmentId, page = 1, q = '', sort = '', dir = '') {
    return axios.get(
      `${this.url}/${segmentId}/members?page=${page}&q=${encodeURIComponent(q)}&sort=${sort}&dir=${dir}`
    );
  }

  exportMembers(segmentId) {
    return axios.get(`${this.url}/${segmentId}/export_members`, {
      responseType: 'blob',
    });
  }
}

export default new SegmentsAPI();
